export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              关于我们
            </h2>
            <p className="text-sm text-foreground-500">了解吃瓜黑料爆料的故事</p>
          </div>
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-xl">
                <i className="ri-fire-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-950">吃瓜黑料爆料</span>
            </div>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                吃瓜黑料爆料成立于2024年，是国内领先的娱乐八卦爆料讨论社区。我们汇聚了来自全网的黑料爆料贴吧网友分享和吃瓜群众实时交流，覆盖娱乐圈、网红圈、综艺影视等多个领域的八卦小道消息。
              </p>
              <p>
                平台坚持"真实、及时、多元"的内容理念，通过严格的审核机制和社区自治，力求为每一位瓜友创造一个值得信赖的吃瓜交流空间。无论是明星塌房、综艺争议、恋情实锤还是行业黑幕，你都能在这里找到最全面、最新鲜的爆料资讯。
              </p>
              <p>
                截至目前，吃瓜黑料爆料已拥有超过200万活跃用户，每日产生数万条高质量讨论内容，已经成为中文互联网最具影响力的八卦爆料社区之一。我们相信，吃瓜不仅是一种娱乐方式，更是公众关注社会现象、参与公共讨论的重要途径。
              </p>
            </div>
            <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t border-background-200">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-500">200万+</div>
                <div className="text-xs text-foreground-400 mt-1">注册用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-500">50万+</div>
                <div className="text-xs text-foreground-400 mt-1">累计爆料帖</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary-500">99.9%</div>
                <div className="text-xs text-foreground-400 mt-1">内容过审率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}